import { render, staticRenderFns } from "./Uom.vue?vue&type=template&id=bcd9f042&"
import script from "./Uom.vue?vue&type=script&lang=js&"
export * from "./Uom.vue?vue&type=script&lang=js&"
import style0 from "./Uom.vue?vue&type=style&index=0&id=bcd9f042&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports